const defaultPalette = {
    primary: "#5c90d2",
    secondary: "#2c689c",
    tertiary: "#212a37",
    danger: "#b7433f",
    success: "#559554",
    warning: "#e8db05",
    default: "#ececec",
    grey: "#e0e0e0",
    darkGrey: "#797979",
    section: "#717171",
    font: "#3e3e3e",
    sidebarSectionLabel: "#728195",
    background: "#ececec",
    formLabel: "#797979",
    formBackground: "#ececec",
    formBackgroundActive: "#e0e0e0",
};
export default defaultPalette;
